import React from "react";

const useInput = (validate) => {
  const [value, setValue] = React.useState("");
  const [isTouched, setIsTouched] = React.useState(false);

  const isValid = validate(value);
  const hasError = !isValid && isTouched;

  const inputChangeHandler = React.useCallback((event) => {
    setValue(event.target.value);
  },[]);

  const inputBlurHandler = React.useCallback((event) => {
    setIsTouched(true);
  },[]);

  const touch = React.useCallback(() => {
    setIsTouched(true);
  },[]);

  const reset = React.useCallback(() => {
    setValue("");
    setIsTouched(false);
  },[]);

  return { value, isValid, hasError, inputChangeHandler, inputBlurHandler, reset, touch };
};
export default useInput;
